import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import lojas from '@/domains/shared/configuracoes/lojas/router/routes'
import usuarios from '@/domains/shared/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/shared/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/shared/configuracoes/permissoes/router/routes'
import planos from '@/domains/shared/configuracoes/planos/router/routes'
import dominios from '@/domains/shared/configuracoes/dominios/router/routes'
import ajuda from '@/domains/shared/auxiliares/ajuda/router/routes'
import movimentacoesFinanceiras from '@/domains/financeiro/movimentacoes/router/routes'

const Externo = () => import('@/shared/layouts/adminlte/components/ExternoBarra')

let childrenRoutes = []
const paths = require.context('../domains/', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})

const routes = [
    {
        path: '',
        component: Externo,
        children: [
            {
                path: '/banco_inter/pix/imprimir_pix/:integracao/:hash',
                component: () => import('../domains/pix/views/VisualizarQrCode'),
                meta: {
                    public: true
                },
            },
        ],
    }, 
    {
        path: '/banco_inter',
        component: () => import('@/shared/components/layout/Interno'),
        children: childrenRoutes,
    },
    {
        path: '/banco_inter/sistema/acessar_erp',
        redirect: '/inicio'
    },
    {
        path: '/banco_inter/transacoes/imprimir_pdf/:integracao/:nossoNumero',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        path: '/banco_inter/pix/imprimir_pix_pdf/:integracao/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        path: '/banco_inter/pix/imprimir_comprovante/:integracao/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        path: '/banco_inter/pix/qr/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    ...formataRotasGlobais('banco_inter', dominios),
    ...formataRotasGlobais('banco_inter', lojas),
    ...formataRotasGlobais('banco_inter', usuarios),
    ...formataRotasGlobais('banco_inter', gruposUsuarios),
    ...formataRotasGlobais('banco_inter', permissoes),
    ...formataRotasGlobais('banco_inter', planos),
    ...formataRotasGlobais('banco_inter', ajuda),
    ...formataRotasGlobais('banco_inter', movimentacoesFinanceiras),
]

router.addRoutes(routes)

export default router
